/**
 * Cookie consent storage.
 * Strictly-necessary cookies are always considered enabled; this flag only
 * gates non-essential cookies (currently: GA4 analytics).
 *
 * Values:
 *   "granted"  — user accepted analytics cookies
 *   "denied"   — user declined analytics cookies
 *   null       — user has not yet decided (banner should be shown)
 */
const KEY = "quantum_consent_v1";
const EVENT = "quantum:consent-changed";

export const CONSENT_GRANTED = "granted";
export const CONSENT_DENIED = "denied";

export function getConsent() {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.value === CONSENT_GRANTED || parsed?.value === CONSENT_DENIED
      ? parsed.value
      : null;
  } catch {
    return null;
  }
}

export function setConsent(value) {
  if (value !== CONSENT_GRANTED && value !== CONSENT_DENIED) return;
  try {
    window.localStorage.setItem(
      KEY,
      JSON.stringify({ value, at: new Date().toISOString() }),
    );
    window.dispatchEvent(new CustomEvent(EVENT, { detail: value }));
  } catch {
    /* localStorage may be blocked; banner will re-appear next visit */
  }
}

export function onConsentChange(handler) {
  const listener = (e) => handler(e.detail);
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}
